module.exports = __webpack_public_path__ + "static/media/ic-whatsapp.c561ce4f.svg";